import React from 'react';

// Create a new context
const RootContext = React.createContext();

export default RootContext;
